import { BrowserRouter as Router } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import AuthProvider from 'context/authContext'
import PriceLabelUnseenCountProvider from 'context/priceLabelUnseenCountContext'
import NewSapBarcodeUnseenCountProvider from 'context/newSapBarcodeUnseenCountContext'
import RoutesProvider from 'routes'

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            duration: 1500,
            style: {
              borderRadius: '4px',
            },
          }}
        />
        <PriceLabelUnseenCountProvider>
          <NewSapBarcodeUnseenCountProvider>
            <RoutesProvider />
          </NewSapBarcodeUnseenCountProvider>
        </PriceLabelUnseenCountProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
